import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { Box, CircularProgress } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ActionButton } from "./ActionButton/ActionButton";
import { IActionsProps } from "./models";

const translationPath = "components.reportsModal.actions.";

export const Actions = memo(
  ({
    isActive,
    isLoading,
    selectedFile,
    viewHandler,
    funcHandler,
    handleDownloadFile,
    showViewButton = true,
    showDownloadButton = true,
    cdnUrl = false,
  }: IActionsProps) => {
    const { t } = useTranslation();
    const [shouldOpenFile, setShouldOpenFile] = useState(false);

    const openInNewTabHandler = useCallback(async () => {
      await funcHandler();
      setShouldOpenFile(true);
    }, [funcHandler]);

    useEffect(() => {
      if (!shouldOpenFile || !selectedFile) return;

      setShouldOpenFile(false);

      // if (cdnUrl) {
      //   window.open(selectedFile as string, "_blank");
      //   return;
      // }

      try {
        let blob: Blob;

        if (selectedFile instanceof ArrayBuffer) {
          blob = new Blob([selectedFile], { type: "application/pdf" });
        } else {
          const base64String = (selectedFile as string).includes(",")
            ? (selectedFile as string).split(",")[1]
            : (selectedFile as string);

          const byteCharacters = atob(base64String);
          const byteArray = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
          }
          blob = new Blob([byteArray], { type: "application/pdf" });
        }

        const blobUrl = URL.createObjectURL(blob);
        const newTab = window.open();
        if (newTab) newTab.location.href = blobUrl;
      } catch (e) {
        console.error("[PDF] Erro ao abrir arquivo:", e);
      }
    }, [selectedFile, shouldOpenFile, cdnUrl]);

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {isLoading && <CircularProgress size={18} />}
        <ActionButton
          icon={OpenInNewRoundedIcon}
          tooltip={t(`${translationPath}open`)}
          disabled={isLoading}
          onClick={openInNewTabHandler}
        />
        {showViewButton && (
          <ActionButton
            icon={VisibilityRoundedIcon}
            tooltip={t(`${translationPath}view`)}
            disabled={isActive || isLoading}
            onClick={viewHandler}
          />
        )}
        {showDownloadButton && (
          <ActionButton
            icon={DownloadRoundedIcon}
            tooltip={t(`${translationPath}download`)}
            disabled={isLoading}
            onClick={handleDownloadFile}
          />
        )}
      </Box>
    );
  }
);